package core.localization

import core.enums.ELocalizationKeys

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 11.10.22
 * Author : mariorosshirt
 */
object Localization {

    fun getLocalizationKey(key: String): String {
        val localizationJson = kotlinext.js.require("./localization/de.json")
        return localizationJson[key] as? String ?: ""
    }

    fun getLocalizationKey(key: ELocalizationKeys): String {
        return getLocalizationKey(key.name)
    }


}